import axios from "axios";
import { apiServicesUrl } from "./baseUrl";

export const signUp = (data, token) => {
  return axios.post(`${apiServicesUrl}/users/user-registration-new`, data, {
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      "X-TOKEN": token,
    },
  });
};
